import { BaseInfo, Info, OtherInfo, TypographyWrapper, UserPanel } from "@/views/MainHeader/PersonalInfo/styled";
import { getRoleLabel } from "@/type/user";
import { LogoutOutlined } from "@ant-design/icons";
import { useAppSelector } from "@redux/store";
import { logout } from "@services/auth";
import { Button, Descriptions, Divider, Image, Typography } from "antd";

function InfoPanel() {
  const user = useAppSelector(state => state.user);
  const roleLabel = getRoleLabel(user);
  return (
    <UserPanel>
      <BaseInfo>
        <Image src={`https://badgephotos.corp.amazon.com/?uid=${user.username}`} />
        <Info>
          <p>{user?.username}</p>
        </Info>
      </BaseInfo>
      <OtherInfo column={1} size="small" layout="vertical">
        <Descriptions.Item label="Role">
          <TypographyWrapper>
            <Typography.Text>{roleLabel ?? "—"}</Typography.Text>
          </TypographyWrapper>
        </Descriptions.Item>
      </OtherInfo>
      <Divider style={{ margin: "12px 0 8px" }} />
      {/*
        No "you may be signed back in silently" caveat any more. Logout now goes through the
        backend, which ends the edge gate's session and either ends the provider session
        (Cognito) or forces a credential prompt on the next sign-in (Federate, IdPrism).
      */}
      <Button type="text" danger icon={<LogoutOutlined />} onClick={() => logout()} block style={{ textAlign: "left" }}>
        Sign Out
      </Button>
    </UserPanel>
  );
}

export default InfoPanel;
